/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../models/transaction_details';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "RetrieveTransactionDetailsRequest": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "accountId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetrieveTransactionDetailsResponse": {
                    "fields": {
                      "transactionDetails": {
                        "type": ".squareup.sfs.models.TransactionDetails",
                        "id": 1,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveTransactionDetailsRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.RetrieveTransactionDetailsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveTransactionDetailsRequest @ squareup/sfs/external/services/transfer/retrieve_transaction_details.proto at 9:1
 */
export const RetrieveTransactionDetailsRequest = $root.lookupType('squareup.sfs.external.service.RetrieveTransactionDetailsRequest');
fixType(RetrieveTransactionDetailsRequest, {
  id: {
    required: true
  }
});
Builder.createAndAttachToType(RetrieveTransactionDetailsRequest);
/**
 * SOURCE RetrieveTransactionDetailsResponse @ squareup/sfs/external/services/transfer/retrieve_transaction_details.proto at 26:1
 */
export const RetrieveTransactionDetailsResponse = $root.lookupType('squareup.sfs.external.service.RetrieveTransactionDetailsResponse');
fixType(RetrieveTransactionDetailsResponse);
Builder.createAndAttachToType(RetrieveTransactionDetailsResponse);